/* ===== Shenbai Home JS ===== */
/* Synced from HTML pages - Home page specific interactions */
(function() {
    'use strict';

    // Re-run scroll animations when sections are added/edited (Shopify theme editor)
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', function() {
            // Re-observe fade elements
            document.querySelectorAll('.fade-up, .fade-left, .fade-right').forEach(function(el) {
                if (!el.classList.contains('visible')) {
                    var observer = new IntersectionObserver(function(entries) {
                        entries.forEach(function(entry) {
                            if (entry.isIntersecting) {
                                entry.target.classList.add('visible');
                                observer.unobserve(entry.target);
                            }
                        });
                    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
                    observer.observe(el);
                }
            });
        });
    }

})();
